/* eslint-disable */
import React,{useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import PopSuspension from './_PopSuspension';
function SuspensionList() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title:"국어", cnt:"45", value:0},
    {title:"영어", cnt:"45", value:1},
    {title:"수학", cnt:"45", value:2},
    {title:"과탐", cnt:"45", value:3},
    {title:"사탐", cnt:"45", value:4},
    {title:"논술", cnt:"45", value:5},
    {title:"면접", cnt:"45", value:6},
    {title:"생디", cnt:"45", value:7},
  ];
  const [modalSuspension, setModalSuspension] = useState(false);
  return (
    <main className="com_container p_suspension_list">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu1_7'>중단우려회원</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalSuspension(true)} className="com_btn orange s btn_plus">중단 우려회원 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className='com_board_list__top'>
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />
            <div className='com_board_list__top'>
              <section className='com_board_search end'>
                <article className='search'>
                  <input type="search" placeholder='검색할 내용을 입력' className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className='com_board_list'>
              <colgroup>
                <col width="4%"/><col width="10%"/>
                <col width="8%"/><col width="8%"/>
                <col width="5%"/><col width="5%"/>
                <col width="15%"/><col width="10%"/>
                <col width="5%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>학생명</th>
                  <th>휴대폰</th>
                  <th>과목</th>
                  <th>등록자</th>
                  <th>제목</th>
                  <th>상태</th>
                  <th>답변자</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>11</td>
                  <td className='td_date'>2022.08.25 12:30</td>
                  <td>가길동102</td>
                  <td>010-222-2222</td>
                  <td>수학</td>
                  <td>홍길동102</td>
                  <td>개인사정으로 수업이 어렵다고 하네요</td>
                  <td>가길동102</td>
                  <td className='td_red'><button className="name btn_link">답변대기</button></td>
                </tr>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className='td_date'>2022.08.25 12:30</td>
                      <td>가길동102</td>
                      <td>010-222-2222</td>
                      <td>수학</td>
                      <td>홍길동102</td>
                      <td>개인사정으로 수업이 어렵다고 하네요</td>
                      <td>가길동102</td>
                      <td className='td_point'><button className="name btn_link">김담임</button></td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <button className="btn_edit"/>
                <button className="btn_delete"/>
              </div>
            </div>
            <div className="com_detail_top">
              <button className="state stop">인계</button>
              <div className="info stop">
                <p className="tit">인계3</p>
                <span className="dot"></span>
                <p className="txt">교사의 불성실 사유로 인한 중단</p>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont"><button className="name btn_link">홍길동103 </button><span className="desc"> (고3ㆍ경기고등학교ㆍ본사) </span></span>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <div className="cont">
                    <p className="txt">010-1234-233</p>
                  </div>
                </div>
                <div className="info">
                  <span className="tit">부모폰</span>
                  <div className="cont">
                    <p className="txt"><span>부)010-1234-233</span><span className="dot" /><span>모)010-1234-233</span></p>
                  </div>
                </div>
                <div className="info">
                  <span className="tit">홍보</span>
                  <span className="cont"><button className="name btn_link">김홍보302</button></span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont"><button className="name btn_link">김담임302</button></span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont">과탐</span>
                </div>
                <div className="info">
                  <span className="tit">수업상세</span>
                  <span className="cont">사회문화, 경제, 밥과정서</span>
                </div>
                <div className="info">
                  <span className="tit">DC금액 / 사유</span>
                  <span className="cont">50,000 / 2기 수업으로</span>
                </div>
                <div className="info">
                  <span className="tit">기수 / 타임</span>
                  <span className="cont">2기 / 2T</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">완성여부</span>
                  <span className="cont">Y</span>
                </div>
                <div className="info">
                  <span className="tit">비교수업</span>
                  <span className="cont">N</span>
                </div>
                <div className="info">
                  <span className="tit">첫 수업일</span>
                  <span className="cont">2023.05.05 19:30</span>
                </div>
                <div className="info">
                  <span className="tit">마지막 수업일</span>
                  <span className="cont">2023.05.09 19:30</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 장소</span>
                  <span className="cont">경기도 수원시 팔달구 팔달로1465  모여라 빌딩 203호</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">진행 수업 수</span>
                  <span className="cont">45 / 65</span>
                </div>
                <div className="info">
                  <span className="tit">최근 수업일</span>
                  <span className="cont">2023, 05, 08  12:30</span>
                </div>
                <div className="info">
                  <span className="tit">진행률</span>
                  <span className="cont">65%</span>
                </div>
              </div>
              <div className="board_item">
              김학생이 개인 사정으로 다음주 까지만 <br />수업을 진행하려 합니다.
              </div>
            </div>
            <div className="com_comment_wrap">
              <textarea className="textarea" placeholder='내용을 입력해주세요'></textarea>
            </div>
            <hr className="com_divider" />
            <div className="com_comment_wrap type_board short">
              <ul className="comment_list">
              {[1,2].map((i,idx) => {
                return (
                  <li className="item" key={idx}>
                    <div className="info">
                      <p className="name">홍길동104</p>
                      <span className="dot" />
                      <p className="date">2023.05.20 11:30</p>
                      <div className="com_btn_wrap">
                        <button className="btn_edit"></button>
                        <button className="btn_delete"></button>
                      </div>
                    </div>
                    <p className="txt">
                      축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!<br />
                      축하드려요~!
                    </p>
                  </li>
                  )
                })}
              </ul>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder='댓글을 입력해주세요' />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopSuspension open={modalSuspension} close={() => setModalSuspension(false)} />
   </main>
  );
}

export default SuspensionList;
